var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "gap-x-6 gap-y-3 grid grid-cols-2 sm:gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-3 whitespace",
    },
    _vm._l(_vm.items, function (item) {
      return _c(
        "div",
        {
          key: item.id,
          staticClass: "sm:mr-0 w-full relative cursor-pointer",
          on: {
            click: function ($event) {
              return _vm.handleClick(item)
            },
          },
        },
        [
          _c("img", {
            staticClass: "rounded-lg w-full aspect-square object-cover",
            attrs: { src: _vm.imageBaseUrl + item.picUrl, alt: "城市列表" },
          }),
          _c("div", { staticClass: "pt-3" }, [
            _c("div", { staticClass: "flex items-center justify-between" }, [
              _c(
                "h3",
                {
                  staticClass: "text-sm font-semibold text-gray-800 truncate",
                  attrs: { title: item.title },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$store.getters.isZh ? item.name : item.nameEn
                      ) +
                      " "
                  ),
                ]
              ),
            ]),
            _c(
              "span",
              {
                staticClass:
                  "absolute top-2 left-2 text-xs text-orange-600 bg-white px-3 py-1 rounded-full border border-gray-300",
              },
              [_vm._v(" " + _vm._s(item.type === "SIM" ? "SIM" : "eSIM") + " ")]
            ),
            _c("div", { staticClass: "pl-2" }, [
              _c("div", { staticClass: "text-xs text-gray-800" }, [
                _vm._v(_vm._s(_vm.isZh ? item.place : item.placeEn)),
              ]),
            ]),
          ]),
          _vm.showLiked
            ? _c("van-icon", {
                staticClass: "absolute top-2 right-2",
                attrs: {
                  name: item.favorite ? "like" : "like-o",
                  color: item.favorite ? "#ff7a00" : "#999",
                  size: "28",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleFavorite(item)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }